import './styles/fonts.css'
import './ds/tokens.css'
import './ds/motion.css'
import './ds/ds.css'
import './styles/edimi.css'
import './styles/app.css'
import './styles/kit.css'
import './styles/screens.css'
import './styles/packs.css'
import './styles/lyrics-advanced.css'
import './styles/studio.css'
import './styles/trim.css'
import './styles/billing.css'
import './styles/peripheral.css'
import './styles/spa.css'
// Język minimal (MINIMAL-2026-09-18): nadpisuje anatomię komponentów DS i arkuszy
// ekranów, więc stoi PO nich — i przed `touch.css`, który ma zostać ostatni.
import './styles/minimal.css'
import './styles/minimal-desktop.css'
import './styles/product-scale.css'
import './styles/workspace-library.css'
import './styles/workspace-publishing.css'
// Ekran „Opcje zaawansowane” napisów (paczka 32c): stoi PO minimal.css i po
// product-scale.css, bo nadpisuje układ `.mn-page` / `.mn-module` dla dwóch kolumn.
import './styles/minimal-lyrics-adv.css'
// 45-B (C0): ekran /powiadomienia i dzwonek powloki (paczka PW, prefiks `ntf-`).
import './styles/minimal-powiadomienia.css'
// LAST on purpose: the phone touch contract (MINIMAL-2026-09-18) overrides selection
// and field-size rules the sheets above set, several of which tie it on specificity.
import './styles/touch.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { I18nProvider, useAdoptUserLocale } from './lib/i18n'
import { ToastProvider } from './ds/feedback/Toast'
import { ConfirmProvider } from './ds/feedback/useConfirm'
import { appFetch } from './lib/http'
import { IS_NATIVE, apiUrl } from './lib/native'
import { installTouchGuard } from './lib/touchGuard'
import App from './App'

// First-party, cookie-less visit beacon for the admin "daily visits" stat (SPEC §D6).
// Fire-and-forget at module load (outside React, so no StrictMode double-count); the
// endpoint is anonymous + CSRF-exempt + IP rate-limited.
try {
  void appFetch(apiUrl('/api/pageview'), { method: 'POST', keepalive: true }).catch(() => {})
} catch {
  /* non-browser env */
}

// Pinch / double-tap guard, once, outside React. Every handler is inert until a
// shell puts `is-app` on <html>, so public and legal pages keep their zoom.
installTouchGuard()

// Native-only shell wiring (Android back button, …). Dynamic import so the
// @capacitor/* modules never enter the web bundle.
if (IS_NATIVE) {
  void import('./lib/nativeShell').then((m) => m.initNativeShell()).catch(() => {})
}

// Bridge the authenticated User.locale into the i18n provider (unless the visitor has
// made an explicit pick). Lives inside both providers so it can read auth + set locale.
function LocaleBridge() {
  const { user } = useAuth()
  useAdoptUserLocale(user?.locale)
  return null
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider>
          <ToastProvider>
            <ConfirmProvider>
              <LocaleBridge />
              <App />
            </ConfirmProvider>
          </ToastProvider>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
